if(!customElements.get('search-bar')){
    class SearchBar extends HTMLElement {
        constructor(){
            super();

            this.id = this.dataset.id;
        }

        connectedCallback(){
            this.selectedFilter = this.querySelector(".filter-wrapper");
            this.getFilterByTrigger();

            this.selectedFilterValues = [];

            this.searchInput = this.querySelector(".input-search");
            this.searchInputForm = this.querySelector(".search-bar__form");

            this.searchInputForm?.addEventListener("submit", (e) => {
                e.preventDefault();
                const searchTerm = this.searchInput.value.trim();
                
                if(!searchTerm.length){
                    this.searchInput.value = '*';
                }

                this.searchInputForm.submit();
            });

            // predictive search
            this.predictiveSearch = this.querySelector(".predictive-search-content");
            if(this.predictiveSearch){
                this.predictiveSearchHTML = this.querySelector(".predictive-search");
                this.loadingBar = this.querySelector(".predictive-search__loading");

                this.showVendor = this.predictiveSearchHTML.dataset.showVendor;
                this.showPrice = this.predictiveSearchHTML.dataset.showPrice;
                this.numItems = this.predictiveSearchHTML.dataset.numItems;

                this.predictiveSearchContent = this.querySelector('.predictive-search-content');

                this.searchInput.addEventListener('input', this.debounce((e) => {
                    const searchTerm = this.searchInput.value.trim();
                    if(this.query !== searchTerm){
                        this.query = searchTerm;
                        
                        if(this.trigger !== 'price') this.getFilterByTrigger();
                    }

                    if(searchTerm === ""){
                        this.closePredictiveSearch();
                    }else{
                       this.openPredictiveSearch(e);
                    }
                   
                }, 300).bind(this));

                window.addEventListener("keydown", (e) => {
                    if(e.key === 'Escape'){
                        this.closePredictiveSearch();
                    }
                });
            }
        }

        disconnectedCallback(){
            if(this.boundClosePredictive){
                document.removeEventListener("pointerdown", this.boundClosePredictive);
            }
            if(this.boundCloseFilterOutside){
                document.removeEventListener("pointerdown", this.boundCloseFilterOutside);
            }
        }

        getFilterByTrigger(){
            if(!this.selectedFilter) return;
            this.trigger = this.selectedFilter.dataset.selectedFilter;
            if(this.trigger){
                this.getFilters(this.trigger, this.selectedFilter);
            }
        }
        
        closePredictiveSearch(){
            this.loadingBar.setAttribute('aria-hidden', 'true');

            this.predictiveSearchContent.setAttribute('aria-hidden', 'true');
            this.predictiveSearchContent.setAttribute('inert', '');

            this.predictiveSearchHTML.innerHTML = '';

            document.removeEventListener("pointerdown", this.boundClosePredictive);
        }

        openPredictiveSearch(e){
            this.loadingBar.setAttribute('aria-hidden', 'false');
                    
            this.predictiveSearchContent.setAttribute('aria-hidden', 'false');
            this.predictiveSearchContent.removeAttribute('inert');

            this.predictiveSearchHTML.innerHTML = ''; // clear search result

            this.onChangeSearchInput(e);
            // this.activeInput();

            this.boundClosePredictive = this.onClickOutsideElement.bind(this);
            document.addEventListener("pointerdown", this.boundClosePredictive);
        }

        onChangeSearchInput(e){
            const searchTerm = this.searchInput.value.trim();

            if(!searchTerm.length){
                this.closePredictiveSearch();
                return;
            }

            this.getSearchResults(searchTerm);
        }

        getSearchResults(searchTerm){
            var formValues = this.getFilterValues();
            if(!formValues){
                formValues = `q=${searchTerm}`;
            }

            const url = `/search?${formValues}&resources[limit]=${parseInt(this.numItems)}&section_id=search-bar-predictive-search&resources[limit_scope]=each`;
            
            fetch(url)
            .then((response) => {
                if(!response.ok){
                    var error = new Error(response.status);
                    this.closePredictiveSearch();
                    throw error;
                }

                return response.text();
            }).then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#search-bar-predictive-search-results').innerHTML;
                this.predictiveSearchHTML.innerHTML = resultsMarkup;

                // if no item and filter exists
                if(this.predictiveSearchHTML.querySelectorAll('[data-with-filter]').length > 0 && this.selectedFilter){
                    const noResultText = this.predictiveSearchHTML.querySelector('[data-with-filter]').dataset.withFilter;
                    this.predictiveSearchHTML.querySelector('[data-with-filter]').innerHTML = `${noResultText}`;
                }

                this.predictiveSearchContent.setAttribute('aria-hidden', 'false');
                this.predictiveSearchContent.removeAttribute('inert');
                this.loadingBar.setAttribute('aria-hidden', 'true');
                this.predictiveSearchHTML.setAttribute('aria-hidden', 'false');
            }).catch(error => {
                this.closePredictiveSearch();
                throw error;
            });
        }

        getFilterValues(){
            const qs = this.formToQueryString(this.searchInputForm);
            return qs;
        }

        formToQueryString(form) {
            return new URLSearchParams(new FormData(form)).toString();
        }

        onClickOutsideElement(e){
            if(e.target.classList.contains('custom-input-wrapper--search') || e.target.closest('.custom-input-wrapper--search')) return;

            this.closePredictiveSearch();
        }

        activeInput(){
            const searchInputForm = this.querySelector(`.search-bar__form`);
            if(!searchInputForm) return;

            if(document.activeElement === this.searchInput || this.searchInput.value.trim()){
                searchInputForm.classList.add('active');
            }else{
                searchInputForm.classList.remove('active');
            }
        }

        debounce(fn, wait){
            let t;
            return (...args) => {
              clearTimeout(t);
              t = setTimeout(() => fn.apply(this, args), wait);
            }
        }

        getFilters(filterTrigger, el){
            const query = (this.query)? this.query : '*';
            filterTrigger = filterTrigger.toLowerCase();

            fetch(`/search?q=${query}&section_id=search-filter`)
            .then((response) => {
                if(!response.ok){
                    var error = new Error(response.status);
                    throw error;
                }
                return response.text();
            }).then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector(`#shopify-section-search-filter .filter-wrapper[data-selected-filter=${filterTrigger}]`);
                if(filterTrigger === 'price'){
                    if(resultsMarkup){
                        el.innerHTML = resultsMarkup.innerHTML;
                    }
                }else{
                    if(resultsMarkup){
                        el.innerHTML = resultsMarkup.innerHTML;
                        this.handleEvents(el);
                        this.selectCurrentFilterValue(el);
                    }else{
                        if(el.querySelector('.input--dropdown-selected-option span')){
                            el.querySelector('.input--dropdown-selected-option span').innerHTML = el.dataset.noFilter;
                        }
                        
                        if(el.querySelector('.input--dropdown-options')){
                            el.querySelector('.input--dropdown-options').innerHTML = '';
                        }
                        this.handleEvents(el);
                    }
                }
            }).catch(error => {
                throw error;
            });
        }

        selectCurrentFilterValue(el){
            el.querySelectorAll('li').forEach(item => {
                const value = item.dataset.option;
                this.selectedFilterValues.forEach(selectedFilterValue => {
                    const checkbox = item.querySelector('input[type="checkbox"]');
                    if(value === selectedFilterValue){
                        checkbox.setAttribute('checked', 'checked');
                    }
                });
            });

            this.enterSelectedDropdownList(el);
        }

        handleEvents(el){
            if(el === null) return;

            const inputFilter = el.querySelector(".input--dropdown-select");
            const buttonFilter = el.querySelector(".input--dropdown-selected-option");
            const dropdownFilter = el.querySelector(".input--dropdown-options");
            const dropdownListFilter = dropdownFilter?.querySelectorAll("li");

            if(!inputFilter) return;
            el.addEventListener("focusout", (e) => {
                const newTarget = e.relatedTarget;
                if(!inputFilter.contains(newTarget)){
                    this.closeDropdownList(e, el);
                }
            });

            buttonFilter?.addEventListener("click", (e) => {
                if(buttonFilter.classList.contains("active")){
                    this.closeDropdownList(e, el);
                }else{
                    this.openDropdownList(e, el);
                }
            });
            buttonFilter?.addEventListener("keydown", (e) => {
                if(e.key === 'Enter'){
                    if(buttonFilter.classList.contains("active")){
                        this.closeDropdownList(e, el);
                    }else{
                        this.openDropdownList(e, el);
                    }
                }
            });

            this.boundCloseFilterOutside = (e) => {
                if(!el.contains(e.target)){
                    this.closeDropdownList(e, el);
                }
            };
            document.addEventListener("pointerdown", this.boundCloseFilterOutside);
            dropdownListFilter.forEach((item, index) => {
                item.addEventListener("click", (e) => {
                    this.selectDropdownOption(item, e);
                });
                item.addEventListener("keydown", event => {
                    if(event.key === 'Enter') this.selectDropdownOption(item, event);
                    else if(event.key === 'ArrowDown'){
                        event.preventDefault();
                        if(index < dropdownListFilter.length - 1){
                            dropdownListFilter[index + 1].focus();
                        }
                    }else if(event.key === 'ArrowUp'){
                        event.preventDefault();
                        if(index > 0){
                            dropdownListFilter[index - 1].focus();
                        }
                    }else if(event.key === 'Escape'){
                        buttonFilter.focus();
                        dropdownFilter.setAttribute("inert", '');
                    }
                });
            });
        }

        selectDropdownOption(el, e){
            if(e.target.nodeName === 'LI' || e.target.className.includes('checkbox-wrapper')){
                const checkbox = el.querySelector('input[type="checkbox"]');
                if(!checkbox) return;

                if(!checkbox.checked){
                    checkbox.setAttribute('checked', 'checked');
                }else{
                    checkbox.removeAttribute('checked');
                }
            }
        }

        openDropdownList(e, el){
            e.preventDefault();

            const buttonFilter = el.querySelector(".input--dropdown-selected-option");
            const dropdownFilter = el.querySelector(".input--dropdown-options");

            if(e.target.nodeName !== 'LI' && e.target.closest('li') == null){
                buttonFilter.classList.add("active");
                dropdownFilter.removeAttribute("inert");
            }
        }

        closeDropdownList(e, el){
            const inputFilter = el.querySelector(".input--dropdown-select");
            const buttonFilter = el.querySelector(".input--dropdown-selected-option");
            const dropdownFilter = el.querySelector(".input--dropdown-options");

            buttonFilter.classList.remove("active");
            setTimeout(() => {
                this.enterSelectedDropdownList(el);

                const active = document.activeElement;
                if(!inputFilter.contains(active)){
                    dropdownFilter.setAttribute("inert", '');
                }
            }, 100);
        }

        enterSelectedDropdownList(el){
            const buttonFilter = el.querySelector(".input--dropdown-selected-option");
            const dropdownFilter = el.querySelector(".input--dropdown-options");
            const dropdownCheckboxes = dropdownFilter?.querySelectorAll('input[type="checkbox"]');

            const selectLabel = [];
            dropdownCheckboxes.forEach(checkbox => {
                if(checkbox.checked){
                    selectLabel.push(checkbox.dataset.label);
                }
            });
            
            this.selectedFilterValues = selectLabel;
            const selectLabelText = selectLabel.length !== 0? selectLabel.join(", ") : buttonFilter.dataset.defaultLabel.trim();
            buttonFilter.querySelector('span').innerText = `${selectLabelText}`;
        }
    }

    customElements.define('search-bar', SearchBar);
}